/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import {Root} from "../framework/BugsBunny/src/index";
import Onboard from "../pages/Onboard";
import { useAuth } from "../services/auth-service/auth.provider";
import { VApplication } from "../application";
import { lazyWithRetry} from "./ComponentLoader";

const LandingPage = lazyWithRetry(() => import("../pages/Landing"));
const TrafficLightPage = lazyWithRetry(() => import("../pages/TrafficLight"))
const LoginPage = lazyWithRetry(() => import("../pages/Login"))
const DashboardPage = lazyWithRetry(() => import("../pages/Dashboard"))
const TermsandConditionScreen = lazyWithRetry(() => import("../pages/TermsAndCondition"));
const PrivacyPolicyScreen = lazyWithRetry(() => import("../pages/PrivacyPolicy"));

const vapp = VApplication.getInstance();
const storageService = vapp.getSync("services.StorageModule");

const loginService = VApplication.getInstance().getSync(
    "services.AuthService"
) as AuthService;

const userDept = storageService.get("userDepartment", "session"); 
const userDeptLocal = storageService.get("userDepartment", "local"); 


console.log("thisisAPPnavigator local:",userDeptLocal, "session",userDept)
const RouterConfig = (props) => (
    <Switch>
        <PrivateRoute path="/dashboard" component={() => (<Root  userDept={userDept?.value ?? userDeptLocal?.value} />)} />
        <Route path="/terms" component={TermsandConditionScreen} />
        <Route path="/privacy" component={PrivacyPolicyScreen} />
        <Route path="/" component={LoginPage} />
    
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            loginService.isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW loaderText={"PCC"}/>}>
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
